import config from '@/config/index'

/** 学员端洞察相关菜单开放域名（按访问域名；本地另开 localhost / 与 baseUrl 同 IP） */
export const INSIGHT_WEB_URL_WHITELIST = ['edu-test.ykumda.com', 'edu.shanxiyixue.com']

export const INSIGHT_ACCOUNT_PATHS = [
  '/account/study-plan',
  '/account/learning-portrait',
  '/account/learning-track',
  '/account/remedy-pack',
]

function normalizeHost(host) {
  return String(host || '')
    .replace(/^https?:\/\//i, '')
    .split('/')[0]
    .split(':')[0]
    .toLowerCase()
    .trim()
}

/** 是否 IPv4 主机名 */
function isIpv4Host(host) {
  return /^\d{1,3}(?:\.\d{1,3}){3}$/.test(String(host || ''))
}

/** 是否本机访问 */
function isLocalAccessHost(host) {
  const h = String(host || '')
  return h === 'localhost' || h === '127.0.0.1'
}

/**
 * 功能：从网关 baseUrl 解析主机名；类型：新增；时间：2026-11-03 18:10:00
 * 整体功能边界条件：空串返回空；非法 URL 回落 normalizeHost；只取 hostname 不含端口路径
 * 思路：用 URL 解析，便于和访问 IP 比对
 */
function hostFromBaseUrl(baseUrl) {
  // 1. 空配置直接空
  const raw = String(baseUrl || '').trim()
  if (!raw) {
    return ''
  }
  // 2. 优先按绝对 URL 解析
  try {
    const withProto = /^https?:\/\//i.test(raw) ? raw : `http://${raw}`
    return String(new URL(withProto).hostname || '').toLowerCase()
  } catch (e) {
    // 3. 解析失败回落手工截取
    return normalizeHost(raw)
  }
}

/**
 * 功能：解析当前访问主机名；类型：修改；时间：2026-11-03 18:10:00
 * 整体功能边界条件：优先入参；客户端用 location.hostname；SSR 用 Host 头；都拿不到则空串
 * 思路：门控以真实访问主机为准，不读 config.url
 */
export function resolveInsightAccessHost(host) {
  // 1. 显式传入则直接规范化
  if (host != null && String(host).trim() !== '') {
    return normalizeHost(host)
  }
  // 2. 浏览器端读真实访问域名
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    return normalizeHost(window.location.hostname)
  }
  // 3. SSR：从请求 Host 头取访问域名
  try {
    if (typeof useRequestHeaders === 'function') {
      const headers = useRequestHeaders(['host'])
      return normalizeHost(headers && headers.host)
    }
  } catch (e) {
    // 4. 非 Nuxt 上下文忽略
  }
  return ''
}

/** 白名单域名，或 localhost，或访问 IP 与 config.baseUrl 的 IP 相同 → 展示洞察菜单 */
export function isInsightWebEnabled(host) {
  // 修改说明：本地 localhost / 与 baseUrl 同 IP 也开放 修改功能开始 #20261103181000 2026-11-03 18:10:00
  // 1. 解析真实访问主机名
  const h = resolveInsightAccessHost(host)
  // 2. 空主机名不开放
  if (!h) {
    return false
  }
  // 3. 易甄学测试/生产主站域名开放
  if (INSIGHT_WEB_URL_WHITELIST.includes(h)) {
    return true
  }
  // 4. 本机 localhost / 127.0.0.1 开放（本地联调）
  if (isLocalAccessHost(h)) {
    return true
  }
  // 5. 用 IP 访问时，仅当与 config.baseUrl 主机 IP 一致才开放
  if (isIpv4Host(h)) {
    const baseHost = hostFromBaseUrl(config && config.baseUrl)
    if (isIpv4Host(baseHost) && h === baseHost) {
      return true
    }
  }
  // 6. 其它域名/IP 不开放
  return false
  // 修改功能结束 #20261103181000
}

export function isInsightAccountPath(path) {
  const p = String(path || '')
  return INSIGHT_ACCOUNT_PATHS.some((item) => p === item || p.startsWith(`${item}/`))
}
